/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class AlarmSourceService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'AlarmSourceService\' loaded');
    }
}

export { AlarmSourceService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/service/AlarmSourceService.js